export default function ({ items }) {
  const parseItem = ({ component, label, icon, link, items, visibleOn, testId, highlight, id }) => {
    const [, type] = [
      [component === 'n-menu-category-select', 'category-select'],
      [component === 'n-menu-dropdown', 'dropdown'],
      [link && link.startsWith('/'), 'internal'],
      [true, 'external']
    ].find(([condition]) => condition === true);

    return {
      label,
      icon,
      type,
      visibleOn: Array.isArray(visibleOn) && visibleOn.length > 0 ? visibleOn : undefined,
      link,
      children: items?.map(parseItem) || [],
      testId,
      highlight,
      id
    };
  };
  return {
    module: 'SMenu',
    items: items.map(parseItem)
  };
}
